import { computed, ref, watch } from 'vue'

export const MENTION_ROW_HEIGHT = 46
const OVERSCAN = 4
const WINDOW_ROWS = 14

export function useMentionWindow(items, selectedIndex, opened, menu) {
  const scrollTop = ref(0)
  const start = computed(() => Math.max(0, Math.floor(scrollTop.value / MENTION_ROW_HEIGHT) - OVERSCAN))
  const end = computed(() => Math.min(items.value.length, start.value + WINDOW_ROWS))
  const rows = computed(() => items.value.slice(start.value, end.value).map((item, offset) => ({ item, index: start.value + offset })))
  const top = computed(() => start.value * MENTION_ROW_HEIGHT)
  const bottom = computed(() => Math.max(0, items.value.length - end.value) * MENTION_ROW_HEIGHT)
  const onScroll = event => { scrollTop.value = event.target.scrollTop }
  watch(items, () => {
    selectedIndex.value = 0
    scrollTop.value = 0
    if (menu.value) menu.value.scrollTop = 0
  }, { flush: 'sync' })
  // Only opening the menu and keyboard navigation should reveal the selection.
  // Hovering a partially visible row must not move the list under the pointer.
  const scrollToSelected = () => {
    if (!opened.value) return
    const top = selectedIndex.value * MENTION_ROW_HEIGHT
    const height = menu.value?.clientHeight || 208
    if (top < scrollTop.value) scrollTop.value = top
    else if (top + MENTION_ROW_HEIGHT > scrollTop.value + height - 12) scrollTop.value = top + MENTION_ROW_HEIGHT - height + 12
    if (menu.value) menu.value.scrollTop = scrollTop.value
  }
  watch(opened, scrollToSelected, { flush: 'sync' })
  return { rows, top, bottom, onScroll, scrollToSelected }
}
